import mediaQuery from '@/lib/styling/mediaQuery';
import styled from '@emotion/styled';
import moment from 'moment';

type CommentCreatedAtProps = {
  createdAt: string;
};

const StyledCreatedAt = styled('span')({
  marginLeft: 8,
  [mediaQuery(860)]: {
    marginLeft: 0,
    fontSize: 13,
  },
});

const CommentCreatedAt = ({ createdAt }: CommentCreatedAtProps) => (
  <StyledCreatedAt>{moment(createdAt).format('L')}</StyledCreatedAt>
);

export default CommentCreatedAt;
